var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "refGoogleLoginButton", staticClass: "googleLoginButton" },
    [
      _c("div", {
        attrs: {
          id: "g_id_onload",
          "data-client_id":
            "784934877165-qiph0fmp0l880763q3o9sjuqqage98mf.apps.googleusercontent.com",
          "data-ux_mode": "popup",
          "data-login_uri":
            _vm.windowLocOrign + _vm.baseDir + "/loginServlet?mode=googleLogin",
          "data-auto_prompt": "false",
        },
      }),
      _c(
        "div",
        { staticClass: "glb-responsive-wrapper" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasGoogleLoginScriptLoaded,
                  expression: "hasGoogleLoginScriptLoaded",
                },
              ],
            },
            [
              _c("div", {
                staticClass: "g_id_signin",
                class:
                  this.responsiveClass == "glb-default" ? "" : "glb-d-none",
                attrs: {
                  "data-type": "standard",
                  "data-shape": "rectangular",
                  "data-theme": "filled_blue",
                  "data-text": "signin_with",
                  "data-size": "large",
                  "data-width": "400",
                  "data-logo_alignment": "left",
                },
              }),
              _vm._l(_vm.googleButtonSizeArray, function (item, index) {
                return _c("div", {
                  key: index,
                  staticClass: "g_id_signin",
                  class:
                    _vm.responsiveClass == "glb-w" + item ? "" : "glb-d-none",
                  attrs: {
                    "data-type": "standard",
                    "data-shape": "rectangular",
                    "data-theme": "filled_blue",
                    "data-text": "signin_with",
                    "data-size": "large",
                    "data-width": item,
                    "data-logo_alignment": "left",
                  },
                })
              }),
            ],
            2
          ),
          _c("loadingBalls", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasGoogleLoginScriptLoaded,
                expression: "!hasGoogleLoginScriptLoaded",
              },
            ],
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }